import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles<{ align: 'center' | 'left' | 'right' }>({ name: 'ContentCard' })((theme, props) => {
    const flexAlign =
        props.align === 'center'
            ? 'center'
            : props.align === 'left'
            ? 'flex-start'
            : props.align === 'right'
            ? 'flex-end'
            : undefined;

    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: 40,
            justifyContent: flexAlign,
            borderRadius: 24,
            background: 'rgba(255, 255, 255, 0.03)',
            backdropFilter: 'blur(40px)',
            [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                padding: '40px 16px'
            }
        },
        picture: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: flexAlign,
            marginBottom: 32
        },
        title: {
            margin: 0,
            color: '#fff',
            textAlign: props.align,
            fontSize: 20,
            fontWeight: 700,
            lineHeight: '30px',
            letterSpacing: '-0.6px'
        },
        subtitle: {
            paddingTop: 2,
            margin: 0,
            color: 'rgba(255, 255, 255, 0.5)',
            textAlign: props.align,
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '27px',
            letterSpacing: '-0.54px'
        },
        description: {
            paddingTop: 8,
            margin: 0,
            color: '#8E8E8E',
            textAlign: props.align,
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '-0.32px'
        },
        additional: {
            paddingTop: 8,
            margin: 0,
            color: '#232323',
            textAlign: props.align,
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '-0.32px'
        },
        actions: {
            paddingTop: 32,
            display: 'flex',
            gap: 12,
            alignItems: 'center',
            justifyContent: flexAlign,
            marginTop: 'auto'
        }
    };
});
